export default {
  cancelReasonLabel: 'Reason for canceling (Optional)',
};